const ALGOLIA = {
  APP_ID: 'KJMJ9TEMMS',
  SEARCH_KEY: '81b10cd8a307d3718c2930e197666a56',
  INDEXES: {
    BLOGS: process.env.NODE_ENV === 'production' ? 'prod_blogs' : 'dev_blogs',
  },
};
const API = {
  URL: {
    FROALA:
      process.env.NODE_ENV === 'production'
        ? 'https://us-central1-guava-vet-blog.cloudfunctions.net/froalaApiFunction'
        : 'https://us-central1-guava-vet-blog-dev.cloudfunctions.net/froalaApiFunction',
  },
};
const FIREBASE = {
  firebaseConfig:
    process.env.NODE_ENV === 'production'
      ? {
          apiKey: 'AIzaSyBUmCr_a7gS9ty56zEG7nQ6KbYkLqPXfao',
          authDomain: 'guava-vet-blog.firebaseapp.com',
          databaseURL: 'https://guava-vet-blog.firebaseio.com',
          projectId: 'guava-vet-blog',
          storageBucket: 'guava-vet-blog.appspot.com',
          messagingSenderId: '350959180760',
          appId: '1:350959180760:web:2b0e74fb2f50d74c7430ad',
        }
      : {
          apiKey: 'AIzaSyBcCQYx4dbni5mVxkPRRI6-CjqM_1q-1tI',
          authDomain: 'guava-vet-blog-dev.firebaseapp.com',
          databaseURL: 'https://guava-vet-blog-dev.firebaseio.com',
          projectId: 'guava-vet-blog-dev',
          storageBucket: 'guava-vet-blog-dev.appspot.com',
          messagingSenderId: '607322517012',
          appId: '1:607322517012:web:d57afa1f2cfe7819714101',
          measurementId: 'G-JSBB0VWGEZ',
        },
};

// if (location.hostname === 'localhost') {
//   FIREBASE.firebaseConfig.databaseURL = 'http://localhost:4000?ns=emulatorui';
// }
// 'http://localhost:5001/guava-vet-blog-dev/us-central1/froalaApiFunction'

export default {
  ALGOLIA,
  API,
  FIREBASE,
};
